import Cookies from 'js-cookie'

function setCookieByDomain(key, value, expires = 0) {
  Cookies.set(key, value, {
    domain: process.env.VUE_APP_MAYI_DOMAIN,
    expires
  })
}

// 分析URL参数，对cookie进行设置
export default function(query) {
  // eslint-disable-next-line
  const {
    tjuserid = '',
    tjusertoken = '',
    groupGuid = '',
    groupguid = '',
    storeGuid = '',
    storeguid = '',
    tjstoreguid = '',
    tjudid = '',
    tjrole = '', // eslint-disable-next-line
    tujia_code = '', // eslint-disable-next-line
    domainAccountUserId = '',
    mref = ''
  } = query

  if (tjuserid && tjuserid !== 'undefined' && tjuserid + '' !== '0') {
    setCookieByDomain(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserId`, tjuserid, 7)
  }
  if (tjusertoken && tjusertoken !== 'undefined' && tjusertoken + '' !== '0') {
    setCookieByDomain(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserToken`, tjusertoken, 7)
  }
  if (tjrole && tjrole !== 'undefined' && tjrole + '' !== '0') {
    setCookieByDomain(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserRole`, tjrole, 7)
  }
  const guid = groupGuid || groupguid
  if (guid && guid !== 'undefined' && guid + '' !== '0') {
    setCookieByDomain(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_groupGuid`, guid, 7)
  }
  const storeId = storeguid || tjstoreguid || storeGuid
  if (storeId && storeId !== 'undefined' && storeId + '' !== '0') {
    setCookieByDomain(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_storeGuid`, storeId, 7)
  }
  if (tjudid && tjudid !== 'undefined' && tjudid + '' !== '0') {
    setCookieByDomain(`${process.env.VUE_APP_MAYI_DOMAIN}tujia_clientDeviceId`, tjudid, 7)
  }
  if (domainAccountUserId && domainAccountUserId !== 'undefined' && domainAccountUserId + '' !== '0') {
    setCookieByDomain(`domainAccountUserId`, domainAccountUserId, 7)
  }
  if (mref && mref === 'client') {
    setCookieByDomain('isclient', 'true', 7)
  }
}
